import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'usd-coin'),
  es: flattenMessages(es, 'usd-coin'),
  ru: flattenMessages(ru, 'usd-coin'),
  zh: flattenMessages(zh, 'usd-coin'),
};
